import { useToast as useChakraToast, UseToastOptions } from '@chakra-ui/react';
import { useCallback } from 'react';

interface AppToastOptions {
  title?: string;
  description?: string;
  duration?: number;
  isClosable?: boolean;
}

const defaultToastOptions: UseToastOptions = {
  duration: 2500,
  isClosable: true,
  position: 'bottom-right',
  variant: 'left-accent'
};

export const useToast = () => {
  const toast = useChakraToast();

  const showToast = useCallback((
    status: 'success' | 'error' | 'warning' | 'info',
    options: AppToastOptions
  ) => {
    return toast({
      ...defaultToastOptions,
      status,
      title: options.title,
      description: options.description,
      duration: options.duration ?? defaultToastOptions.duration,
      isClosable: options.isClosable ?? defaultToastOptions.isClosable,
    });
  }, [toast]);

  const success = useCallback((title: string, description?: string, options?: Partial<AppToastOptions>) =>
    showToast('success', { title, description, ...options }), [showToast]);

  const error = useCallback((title: string, description?: string, options?: Partial<AppToastOptions>) =>
    showToast('error', { title, description, ...options }), [showToast]);

  const warning = useCallback((title: string, description?: string, options?: Partial<AppToastOptions>) =>
    showToast('warning', { title, description, ...options }), [showToast]);

  const info = useCallback((title: string, description?: string, options?: Partial<AppToastOptions>) =>
    showToast('info', { title, description, ...options }), [showToast]);

  return {
    success,
    error,
    warning,
    info
  };
};